import { useEffect, useRef, useState } from 'react';
import { useParams, Redirect, Switch, Route } from 'react-router-dom';
import { PATHNAMES } from '../../admin';
import Panel from './navigation/panel/panel';
import Editor from './editor/editor-main';
import { useDispatch, useSelector } from 'react-redux';
import { EventsState } from '../../../../store/types';
import { clearWorkingEvent, loadWorkingEvent } from '../../../../store/actions/admin/create-event';
import RegistrationEditor from './editor/registration/registration';
import WaitingIndicator from '../../../general-ui/waiting-indicator/waiting-indicator';
import EventHeader from '../../header/event-header';
import Assistant from '../assistant/assistant';
import PrivacyPolicy from './editor/privacy-policy/privacy-policy';
import TermsConditions from './editor/terms-conditions/terms-conditions';
import PostRegisterPreview from "./post-register-preview";
import './homepage.scss';

export default function Homepage(): JSX.Element {
	const { id }: { id: string; } = useParams();

	const {
		CreateEventReducer: {
			workingEvent,
			eventNotFound,
			loadingEvent
		},
		AuthReducer: {
			token,
		},
	} = useSelector((state: EventsState) => state);

	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		if (!loadingEvent && token && id && (!workingEvent || workingEvent.uuid !== id)) {
			dispatch(loadWorkingEvent(id, token!));
		}
	}, [id, workingEvent, dispatch, token, loadingEvent]);

	useEffect(() => {
		if (loading && workingEvent) {
			setLoading(false);
		}
	}, [loading, workingEvent]);


	const firstRender = useRef(true);
	useEffect(() => {
		if (firstRender.current) {
			firstRender.current = false;
			return;
		}
		dispatch(clearWorkingEvent());
	}, [dispatch, id, token]);

	return (
		<div className="homepage-wrapper">
			<EventHeader />
			<div className="homepage-container">
				{!loading ? (
					<>
						<Panel />
						<Switch>
							<Route path={PATHNAMES.Event.PrivacyPolicyPath}>
								<PrivacyPolicy privacy_policy={workingEvent?.privacy_policy} token={token} channel={workingEvent?.channel} eventID={workingEvent?.uuid} />
							</Route>
							<Route path={PATHNAMES.Event.TermsConditionsPath}>
								<TermsConditions terms_id={workingEvent?.terms_id} token={token} channel={workingEvent?.channel} eventID={workingEvent?.uuid} />
							</Route>
							<Route path={PATHNAMES.Event.Registration}>
								<RegistrationEditor />
							</Route>
							<Route path={[PATHNAMES.Event.Landing, PATHNAMES.Event.ThemeLanding]}>
								<Editor />
							</Route>
							<Route>
								<PostRegisterPreview />
							</Route>
						</Switch>
					</>
				) : (
					<div className="loading-page"><WaitingIndicator /></div>
				)}

				{eventNotFound && <Redirect to={PATHNAMES.Events} />}
			</div>
			<Assistant />
		</div>
	);
}
